var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"signin section illustration-section-02",class:[
        _vm.hasBgColor && 'has-bg-color',
        _vm.invertColor && 'invert-color'
    ]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"signin-inner section-inner",class:[
                _vm.topDivider && 'has-top-divider',
                _vm.bottomDivider && 'has-bottom-divider'
            ]},[_c('c-section-header',{staticClass:"center-content",attrs:{"tag":"h1","data":_vm.sectionHeader}}),_c('h4',{staticClass:"center-content"},[_vm._v(_vm._s(_vm.date))]),_c('div',{staticClass:"flex-center",attrs:{"id":"container"}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }